import { type User, usePasswordResetMutation } from '@features/redux/apis/auth';
import { Button, Grid } from '@mui/material';
import { ResetPasswordEffects } from './ResetPasswordEffects';

export const ResetPassword = ({ user }: { user: User }) => {
    const [resetPassword] = usePasswordResetMutation({ fixedCacheKey: 'ResetUserPassword' });
    const handleReset = () => resetPassword({ email: user.email });

    return (
        <>
            <ResetPasswordEffects />
            <Grid item md={4} xs={12} sm={12}>
                <Button variant='outlined' onClick={handleReset} sx={{ height: '100%', width: '100%' }}>
                    Request Pass Reset
                </Button>
            </Grid>
        </>
    );
};
